// import jQuery
import './common/jquery-global';
// import debug
// import debug from 'bows';

// import header
import header from './_header.js'


// set module name for debug

class Site {
    constructor() {
        // wait for dom loaded
        document.addEventListener('DOMContentLoaded', this.ready.bind(this));

    }

    /**
     * Document ready
     */
    ready() {
        // log('DOM ready');
        this.header = new header();
    }

}

export default Site;